// Job utility functions

// Get department display name
export const getDepartmentDisplayName = (dept) => {
  const departmentMap = {
    'engineering': 'Kỹ thuật',
    'marketing': 'Marketing',
    'sales': 'Kinh doanh',
    'hr': 'Nhân sự',
    'finance': 'Tài chính',
    'operations': 'Vận hành',
    'design': 'Thiết kế',
    'product': 'Sản phẩm'
  };
  return departmentMap[dept] || dept;
};

// Get job type display name
export const getJobTypeDisplayName = (type) => {
  const typeMap = {
    'full-time': 'Toàn thời gian',
    'part-time': 'Bán thời gian',
    'contract': 'Hợp đồng',
    'internship': 'Thực tập',
    'freelance': 'Freelance'
  };
  return typeMap[type] || type;
};

// Get experience level display name
export const getExperienceLevelDisplayName = (level) => {
  const levelMap = {
    'entry': 'Mới tốt nghiệp',
    'junior': 'Nhân viên',
    'mid': 'Trung cấp',
    'senior': 'Cao cấp',
    'lead': 'Trưởng nhóm',
    'manager': 'Quản lý'
  };
  return levelMap[level] || level;
};

// Format salary
export const formatSalary = (min, max) => {
  if (!min && !max) return 'Thỏa thuận';
  
  const formatNumber = (num) => {
    if (num >= 1000000) {
      return (num / 1000000) + ' triệu';
    }
    return num.toLocaleString() + ' VND';
  };

  if (min && max) {
    return `${formatNumber(min)} - ${formatNumber(max)}`;
  }
  return formatNumber(min || max);
};

// Format date
export const formatDate = (dateString) => {
  if (!dateString) return '';
  
  try {
    const date = new Date(dateString);
    return date.toLocaleDateString('vi-VN', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  } catch {
    return dateString;
  }
};

// Check if deadline is near
export const isDeadlineNear = (deadline) => {
  if (!deadline) return false;
  const now = new Date();
  const deadlineDate = new Date(deadline);
  const diffDays = Math.ceil((deadlineDate - now) / (1000 * 60 * 60 * 24));
  return diffDays <= 7 && diffDays > 0;
};

// Check if deadline is passed
export const isDeadlinePassed = (deadline) => {
  if (!deadline) return false;
  const now = new Date();
  const deadlineDate = new Date(deadline);
  return deadlineDate < now;
};

// Split text by lines for better display
export const formatTextWithLineBreaks = (text) => {
  if (!text) return '';
  return text.split('\n').map((line, index) => (
    <p key={index}>{line}</p>
  ));
};

// Format requirements as list
export const formatRequirements = (requirements) => {
  if (!requirements) return [];
  return requirements.split('\n').filter(req => req.trim()).map(req => req.trim());
};

// Format benefits as list
export const formatBenefits = (benefits) => {
  if (!benefits) return [];
  return benefits.split('\n').filter(benefit => benefit.trim()).map(benefit => benefit.trim());
}; 